import { makeStyles } from "@material-ui/core";

export const searchStyle = makeStyles((theme) => ({
  circule: {
    color: "#00d4ff",
  },
  addAddressButton: {
    backgroundColor: "#283B52",
    position: "absolute",
    zIndex: 1000,
    right: "calc(100% + 5px)",
    top: 3,
    padding: "0 20px",
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    color: "white",
    cursor: 'pointer',
    fontSize: '.9rem',
    fontWeight: 600
  },
  outContainer: {
    display: "flex",
    position: "fixed",
    top: "15px",
    right: "20px",
    zIndex: "1300",
    width: "50%",
    minWidth: 330,
    maxWidth: 420,
  },
  innerContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    transition: ".8s",
    width: "100%",
    minWidth: 150,
    backgroundColor: "#283B52",
    borderRadius: "10px",
    padding: "8px 2px",
    textAlign: "right",
    position: "absolute",
    right: "0",
    direction: "rtl",
  },
  searchTitle: {
    fontSize: "1.05rem",
    fontWeight: 500,
    color: "white",
  },
  itemsInSearchBy: {
    position: "fixed",
    top: "75px",
    right: "20px",
    zIndex: "1300",
    width: "18%",
    maxWidth: "245px",
    minWidth: "197px",
    backgroundColor: "#283B52",
    borderRadius: "10px",
    padding: "15px 10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  SearchResult: {
    position: "fixed",
    top: "75px",
    right: "20px",
    zIndex: "1200",
    width: "50%",
    maxWidth: 420,
    minWidth: 330,
    backgroundColor: "#283B52",
    borderRadius: "10px",
    padding: "15px 10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  invalid: {
    fontSize: "1.2rem",
    fontWeight: 800,
    textShadow: "0 0 2px #b32d00",
    color: "#e63900",
  },
  switchMode: {
    position: "absolute",
    backgroundColor: 'red'
  }
}));